import React from 'react'
import MetaBaseDashBoardFour from '../../features/MetabaseDashBoard/MetaBaseDashBoardFour'

const MetabaseReport3 = () => {
  return (
    <div><MetaBaseDashBoardFour/></div>
  )
}

export default MetabaseReport3